const initializeCoordinates = ({
  pageOffset,
  windowWidth,
  windowHeight,
  scrollX,
  scrollY,
  documentWidth,
  documentHeight,
  bodyWidth,
  bodyHeight,
  visualViewport,
  target
}) => {
  return {
    pageOffsetLeft: pageOffset.left,
    pageOffsetTop: pageOffset.top,
    pageWidth: documentWidth,
    pageHeight: documentHeight,
    bodyWidth,
    bodyHeight,
    windowWidth,
    windowHeight,
    scrollX,
    scrollY,
    flagX: null,
    flagY: null,
    flagRelativeX: target.flagRelativeX,
    flagRelativeY: target.flagRelativeY,
    targetX: target.offset.left,
    targetY: target.offset.top,
    targetWidth: target.width,
    targetHeight: target.height,
    screenshotWindowX: null,
    screenshotWindowY: null,
    screenshotWindowWidth: null,
    screenshotWindowHeight: null,
    screenshotWindowFlagX: null,
    screenshotWindowFlagY: null,
    screenshotTargetX: null,
    screenshotTargetY: null,
    screenshotTargetWidth: 319,
    screenshotTargetHeight: 200,
    screenshotTargetFlagX: null,
    screenshotTargetFlagY: null,
    visualViewport: {
      width: null,
      height: null,
      pinX: null,
      pinY: null
    }
  };
};

export { initializeCoordinates };
